package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminListingListItem
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class ListingsState(
    val statusFilter: String = "All",
    val search: String = "",
    val page: Int = 1,
    val totalPages: Int = 1,
    val totalCount: Long = 0L,
    val data: AsyncSection<List<AdminListingListItem>> = AsyncSection.Loading,
    val sortBy: String? = null,
    val sortAsc: Boolean = false,
) : MVIState

val LISTING_STATUS_FILTERS = listOf("All", "ACTIVE", "SUSPENDED", "EXPIRED", "SOLD")

sealed interface ListingsIntent : MVIIntent {
    data class SetStatusFilter(val value: String) : ListingsIntent
    data class SetSearch(val value: String) : ListingsIntent
    data class GoToPage(val page: Int) : ListingsIntent
    data class TapListing(val id: String) : ListingsIntent
    data class ReactToFocusTick(val tick: Long) : ListingsIntent
    data object Refresh : ListingsIntent
    data class SetSort(val sortBy: String, val sortAsc: Boolean) : ListingsIntent
}

sealed interface ListingsAction : MVIAction {
    data class Navigate(val path: String) : ListingsAction
}
